import spendGameManager from "../manager/spendGameManager";
import getOneSpendEventById, {getStartOnloadEvent} from "../config/SpendEventConfig";
import {SpendModeEventI} from "../config/SpendInterface";
import NpcDreamHouseItem from "./dreamHouse/NpcDreamHouseItem";
import ProjectBarPrefab from "./dialog/ProjectBarPrefab";
import O1HD from "../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

export class NpcMap {
    [ npc : number] : cc.Node;
}
/**
 *
 */
@ccclass
export default class DreamHousePrefab extends cc.Component {

    @property({type:cc.Prefab,displayName:"项目栏预制体"})
    projectBarPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"npc Item"})
    npcDreamHouseItem : cc.Prefab = null;
    @property({type:cc.Node,displayName:"npc uiNode"})
    npcUiNode : cc.Node = null;
    @property({type:cc.Node,displayName:"返回按钮"})
    backBtnNode : cc.Node = null;

    private mGameLayer : spendGameManager;
    private dataList : SpendModeEventI[] = [];
    private npcNodeMap : NpcMap = new NpcMap();
    private npcArray : string[] = [];

    onLoad () {
        O1HD.on("DreamHousePrefab.removeNpc" , this.removeNpc , this );
    }

    start () {
        this.checkCanBack();
    }

    bindData( gameLayer : spendGameManager ){
        this.mGameLayer = gameLayer;
        this.initNpcData();
        //开始说话
        this.npcTalk( 0 );
    }

    private npcTalk( i ){
        if ( !this.npcArray[i] ) {
            return;
        }
        this.npcNodeMap[this.npcArray[i]].getComponent( NpcDreamHouseItem ).startTalk(()=>{
            this.npcTalk( ++i );
        });
    }

    //初始化npc数据
    initNpcData(  ){
        let i = 0;
        let hasInArray : SpendModeEventI[] = [];
        for ( let npcEventRel of this.mGameLayer.getGameData()._currentEvents ) {
            if ( npcEventRel.todayInvestCoins == 0 ) {
                let eventInfo = getOneSpendEventById( npcEventRel.eventId);
                if ( i <= 2 ) {
                    hasInArray.push( eventInfo );
                    let npcItem = cc.instantiate( this.npcDreamHouseItem );
                    this.npcUiNode.addChild( npcItem );
                    this.npcArray.push( npcEventRel.npc );
                    this.npcNodeMap[ npcEventRel.npc] = npcItem;
                    npcItem.getComponent( NpcDreamHouseItem ).bindData( this.mGameLayer , i ,eventInfo , this );
                }else{
                    this.dataList.push( eventInfo ) ;
                }
                i++;
            }
        }
        this.dataList = this.dataList.concat( hasInArray );
    }

    /**
     * 打开项目栏
     */
    onBtnOpenProjectBar( e , chooseDefine ){
        let projectBarPrefabNode = cc.instantiate( this.projectBarPrefab );
        this.node.addChild( projectBarPrefabNode );
        projectBarPrefabNode.getComponent( ProjectBarPrefab ).bindData( chooseDefine , this.mGameLayer , this );
    }

    checkCanBack(){
        if ( this.mGameLayer.getGameData()._gameDays != 0 ) {
            this.backBtnNode.active = true;
        }else if ( this.mGameLayer.getGameData()._gameDays == 0 && this.mGameLayer.getGameData()._currentCostMoney >= this.mGameLayer.getGameData()._currentDayTargetMoney) {
            this.backBtnNode.active = true;
        }
    }

    /**
     * 移除npc
     * @param npc
     */
    removeNpc( npc : string ){
        let index = this.dataList.findIndex( ( item, index, dataList )=>{
            return item.belongNpc == npc;
        });
        if ( index != -1 ) {
            delete this.npcNodeMap[npc];
            let findIndex = this.npcArray.findIndex( ( item ,index , dataList )=>{
                return item == npc;
            });
            if ( findIndex != -1){
                this.npcArray.splice(findIndex,1);
            }


            this.dataList.splice( index,1 );
            if ( this.dataList.length > this.npcUiNode.childrenCount ) {
                let npcItem = cc.instantiate( this.npcDreamHouseItem );
                this.npcUiNode.addChild( npcItem );
                let npcEventRel = this.dataList.shift();
                this.dataList.push( npcEventRel );
                npcItem.getComponent( NpcDreamHouseItem ).bindData( this.mGameLayer , 0 , npcEventRel , this );
                npcItem.getComponent( NpcDreamHouseItem ).startTalk(()=>{

                });
            }
        }
    }

    /**
     * 返回
     */
    onBtnBack(){
        this.node.removeFromParent();
        this.node.destroy();
    }
}
